import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { isLaunched } from "../lib/launch";

export default function Footer() {
  const launched = isLaunched();
  return (
    <footer className="bg-white border-t border-[var(--border-stone)] mt-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <Logo size={56} />
          <p className="mt-3 text-sm text-[var(--text-muted)]">
            Your personal hub for local UK professionals. Customers post free — trades pay just £3.99/month.
          </p>
        </div>
        <div>
          <h4 className="font-display font-semibold text-[var(--brand-green)] mb-3">For customers</h4>
          <ul className="space-y-2 text-sm text-[var(--text-muted)]">
            {launched ? (
              <>
                <li><Link to="/post-job" className="hover:text-[var(--brand-green)]" data-testid="footer-post-job">Post a job</Link></li>
                <li><Link to="/find-trades" className="hover:text-[var(--brand-green)]" data-testid="footer-find-trades">Find tradespeople</Link></li>
              </>
            ) : (
              <li><Link to="/" className="hover:text-[var(--brand-green)]" data-testid="footer-waitlist-customer">Join the waiting list</Link></li>
            )}
            <li><Link to="/how-it-works" className="hover:text-[var(--brand-green)]" data-testid="footer-how">How it works</Link></li>
            <li><Link to="/blog" className="hover:text-[var(--brand-green)]" data-testid="footer-blog">Blog</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-[var(--brand-green)] mb-3">For trades</h4>
          <ul className="space-y-2 text-sm text-[var(--text-muted)]">
            {launched ? (
              <li><Link to="/register?role=tradesperson" className="hover:text-[var(--brand-green)]" data-testid="footer-join-trader">Join for £3.99/mo</Link></li>
            ) : (
              <li><Link to="/" className="hover:text-[var(--brand-green)]" data-testid="footer-waitlist-trade">Get early-access invite</Link></li>
            )}
            <li><Link to="/pricing" className="hover:text-[var(--brand-green)]" data-testid="footer-pricing">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-[var(--brand-green)] mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-[var(--text-muted)]">
            <li><Link to="/terms" className="hover:text-[var(--brand-green)]" data-testid="footer-terms">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-[var(--brand-green)]" data-testid="footer-privacy">Privacy</Link></li>
            <li><Link to="/faq" className="hover:text-[var(--brand-green)]" data-testid="footer-faq">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--brand-green)]" data-testid="footer-contact">Contact</Link></li>
            <li>
              <button
                type="button"
                onClick={() => import("../lib/consent").then((m) => m.openPreferences())}
                className="hover:text-[var(--brand-green)] underline-offset-2 hover:underline"
                data-testid="footer-cookie-prefs"
              >
                Cookie preferences
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--border-stone)]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-4 text-xs text-[var(--text-muted)] flex flex-col md:flex-row gap-2 md:justify-between">
          <span>© {new Date().getFullYear()} MyHandyHub · myhandyhub.co.uk</span>
          <span>Standard payment processing fees are non-refundable.</span>
        </div>
      </div>
    </footer>
  );
}
